import { View } from '@revelio/data-access';

import { FilterId } from '../filters/types/filters';

export interface SavedFilterSetButtonProps {
  isDisabled?: boolean;
}

// Map FilterId to View for GQL endpoint
export const filterIdToView = (filterId: FilterId): View => {
  switch (filterId) {
    case FilterId.COMPANY:
      return View.Company;
    case FilterId.GEOGRAPHY:
      return View.Geography;
    case FilterId.ROLE:
      return View.Role;
    default:
      // default to TalentDiscovery view (will need to update this when we add screener)
      return View.TalentDiscovery;
  }
};
